module.exports = __webpack_public_path__ + "img/iphone2.e1439a31.png";